import helpers from "../helpers/helpers";
export default {
  modelName: 'sos_request',
  label: 'SOS',
  fields: {
    user_payload: {
      label: '提交人',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'user',
      width: '100px',
      getValue:(item) =>{
        return {id: item.id, name: item.name}
      }
    },
    factory: {
      label: '提交工廠 / 集團',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'factory',
      rules: 'required',
      width: '100px',
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item)
      },
    },
    contact_person: {
      type: 'text',
      label: '聯絡人姓名',
      maxlength: 10,
      rules: 'required'
    },
    contact_way: {
      type: 'select',
      label: '聯絡方式',
      rules: 'required',
      items: [
        {
          text: '電話',
          value: 'tel',
        },
        {
          text: '信箱',
          value: 'email',
        },
      ]
    },
    contact_for: {
      type: 'select',
      label: '詢問主旨',
      rules: 'required',
      items: [
        {
          text: '緊急法律協助',
          value: 'legalAssistance',
        },
        {
          text: '系統操作協助',
          value: 'operationTutorial',
        },
      ],
    },
    tel: {
      type: 'text',
      label: '聯絡電話',
      maxlength: 20,
      getRules: function(fieldsValue) {
        return helpers.methods.$_CMS_getRules(fieldsValue, 'tel')
      },
      rulesErrorMessage: function(fieldsValue) {
        return helpers.methods.$_CMS_getRulesErrorMessage(fieldsValue, 'tel')
      },
    },
    email: {
      type: 'email',
      label: '聯絡信箱',
      maxlength: 50,
      getRules: function(fieldsValue) {
        return helpers.methods.$_CMS_getRules(fieldsValue, 'email')
      },
      rulesErrorMessage: function(fieldsValue) {
        return helpers.methods.$_CMS_getRulesErrorMessage(fieldsValue, 'email')
      },
    },
    remark: {
      type: 'textarea',
      label: '簡述',
      maxlength: 500,
    },
    attaches: {
      parentKey: 'factory',
      requiredField: 'factory',
      type: 'files',
      label: '簡述附件',
      uploadUrl: '/sos_request/attach/',
    },
    assignee: {
      label: '指派人員',
      type: 'belongsTo',
      textKey: 'name',
      rules: 'required',
      modelName: 'admin',
      orderBy: 'no_number',
      orderWay: 'asc',
      noReset: true,
      sm: 6,
    },
    status: {
      type: 'select',
      label: '處理狀態',
      defaultValue: '0',
      rules: 'required',
      items: [
        {
          text: '尚未處理',
          value: 0,
        },
        {
          text: '處理中',
          value: 1,
        },
        {
          text: '處理完畢',
          value: 2,
        },
      ],
    },
    created_admin: {
      label: '建立者',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'user',
      width: '100px',
    },
    status_remark: {
      type: 'textarea',
      label: '處理備註',
      maxlength: 500,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    // updated_info: {
    //   type: "custom",
    //   label: "上次修改時間",
    //   getValue: (item) => {
    //     let _value = item.updated_at;
    //     if (item.updated_admin) {
    //       _value += `  ${item.updated_admin}`;
    //     }
    //     return _value;
    //   },
    // },
  },
};
